import { useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";

/**
 * Gmail-style two-key navigation shortcuts.
 * Press G then H for Home, G then P for Pay, G then D for Deposit, etc.
 * Also: Escape closes any open modal via document click on .modal-backdrop.
 */
const useKeyboardShortcuts = () => {
  const history = useHistory();
  const pendingKey = useRef(null);
  const timerRef = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      // Don't capture when typing in inputs
      const tag = e.target.tagName;
      if (tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT" || e.target.isContentEditable) {
        return;
      }

      // Escape — close open modals
      if (e.key === "Escape") {
        const backdrop = document.querySelector(".modal-backdrop.show");
        if (backdrop) backdrop.click();
        return;
      }

      // Cmd+K handled by CommandPalette, skip here
      if ((e.metaKey || e.ctrlKey) && e.key === "k") return;

      // Two-key navigation: G + <key>
      if (pendingKey.current === "g") {
        clearTimeout(timerRef.current);
        pendingKey.current = null;

        const routes = {
          h: "/dashboard",
          p: "/dashboard/payment/options",
          d: "/dashboard/deposit",
          w: "/dashboard/withdraw",
          c: "/dashboard/conversion",
          a: "/dashboard/portfolio/assets",
          t: "/dashboard/portfolio/history",
          k: "/dashboard/company-cards",
          s: "/dashboard/settings",
        };

        if (routes[e.key]) {
          e.preventDefault();
          history.push(routes[e.key]);
        }
        return;
      }

      if (e.key === "g") {
        pendingKey.current = "g";
        // Reset after 1 second if no second key
        timerRef.current = setTimeout(() => {
          pendingKey.current = null;
        }, 1000);
      }
    };

    window.addEventListener("keydown", handler);
    return () => {
      window.removeEventListener("keydown", handler);
      clearTimeout(timerRef.current);
    };
  }, [history]);
};

export default useKeyboardShortcuts;
